const COLOR_ROTATION = [
  'bg-gray-100 text-gray-700',
  'bg-primary-50 text-primary-700',
  'bg-warning-50 text-warning-700',
  'bg-red-50 text-red-700',
  'bg-teal-50 text-teal-700',
]

interface Props {
  name: string
  sortOrder?: number
  size?: 'sm' | 'md'
}

export function TicketTypeBadge({ name, sortOrder = 0, size = 'sm' }: Props) {
  const color = COLOR_ROTATION[sortOrder % COLOR_ROTATION.length]
  const sizeClass = size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-2.5 py-1 text-sm'
  return (
    <span className={`inline-flex items-center rounded-full font-semibold ${color} ${sizeClass}`}>
      {name}
    </span>
  )
}
